var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"button is-primary is-flex purchase-button is-small",on:{"click":function($event){_vm.$router.push(
      _vm.localePath({
        name: 'id-post-slug-postId',
        params: {
          id: _vm.artist.urlAlias,
          postId: _vm.post._id,
          slug: _vm.urlSlug(_vm.post.title),
          title: `${_vm.artist.nickname} - ${_vm.post.title}`
        }
      })
    )}}},[_c('bag-icon'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('unlockContent')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }